import React from "react";

const BADGES = [
  {
    testid: "saashub-badge",
    href: "https://www.saashub.com/sovereignsignal-app?utm_source=badge&utm_campaign=badge&utm_content=sovereignsignal-app&badge_variant=color&badge_kind=approved",
    src: "https://cdn-b.saashub.com/img/badges/approved-color.png?v=1",
    label: "Approved on SaaSHub",
    alt: "SovereignSignal.app approved on SaaSHub",
    dim: "brightness-75 saturate-50",
  },
  {
    testid: "alternativeto-badge",
    href: "https://alternativeto.net/software/sovereign-signal/about/?utm_source=badge&utm_medium=referral",
    src: "/badge-alternativeto.png",
    label: "Sovereign Signal on AlternativeTo",
    alt: "Sovereign Signal | AlternativeTo",
  },
];

export const TrustBadges = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-3 flex-wrap ${className}`} data-testid="trust-badges">
    {BADGES.map((b) => (
      <a key={b.testid} href={b.href} target="_blank" rel="noopener noreferrer" data-testid={b.testid} aria-label={b.label}>
        <img src={b.src} alt={b.alt} style={{ height: 34, width: "auto" }} className={`opacity-60 hover:opacity-100 hover:brightness-100 hover:saturate-100 transition-[opacity,filter] duration-300 ${b.dim || ""}`} />
      </a>
    ))}
  </div>
);
